export default "__VITE_ASSET__YXUb0t6A__"